import {PipelineConfigJsonSpec} from 'pipelines/StepShapeUtils';

import {
  BACKEND_FIELD_GENERATOR_CONFIG,
  FIELD_ORDER_UI_SCHEMA_KEY,
  ShapeUISchema,
} from '../StepConfigEditorTypes';

function titleCase(key: string): string {
  // Drop a trailing Id/Ids so an id-holding field (schemaId, folderId) reads as the object it selects
  // ("Schema", "Folder"), pluralizing lists (fileIds -> "Files", studyIds -> "Studies").
  // A bare "id" key is left as-is.
  const withoutIdSuffix = key
    .replace(/([^aeiou])yIds$/, '$1ies')
    .replace(/Ids$/, 's')
    .replace(/Id$/, '');
  const label = withoutIdSuffix || key;
  return label
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .replace(/^\w/, (char) => char.toUpperCase());
}

function rowSourceFields(spec: PipelineConfigJsonSpec): Array<string> {
  if (spec.kind !== 'columnMapping') {
    return [];
  }
  return Object.values(spec.fields).flatMap((subfield) =>
    subfield.kind === 'schemaFields' ? [subfield.rowSourceField] : []
  );
}

export function deriveStepUiSchema(configShape: Record<string, PipelineConfigJsonSpec>): ShapeUISchema {
  const keys = Object.keys(configShape);
  const triggerFields = [...new Set(keys.flatMap((key) => rowSourceFields(configShape[key])))];
  return {
    [FIELD_ORDER_UI_SCHEMA_KEY]: keys,
    [BACKEND_FIELD_GENERATOR_CONFIG]: {triggerFields},
    ...Object.fromEntries(keys.map((key) => [key, {displayName: titleCase(key), configShapePath: [key]}])),
  };
}
